import { render, staticRenderFns } from "./RulesTimeDurationInput.vue?vue&type=template&id=644a0d4b"
import script from "./RulesTimeDurationInput.vue?vue&type=script&lang=ts"
export * from "./RulesTimeDurationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports